import { collection, doc } from "firebase/firestore";
import { firestore } from "services/firebaseService/firebaseConfig";

const AUDIO_REACTIONS = "AudioReactions";
const REACTIONS = "reactions";

export const getAudioReactionsRef = (eventId: string) => {
  const eventDocRef = doc(collection(firestore, AUDIO_REACTIONS), eventId);
  return collection(eventDocRef, REACTIONS);
};
